import React from "react";
import useVisibilityState from "../../common/forms/useVisibilityState";
import { SelectView } from "../views/SelectView";
import { ViewActions } from "../views/ViewActions";
import { viewsType } from "../../common/types/search/search";

interface ViewsActionsProps {
	namespace: string;
	resultsAreLoaded: boolean;
	views: viewsType;
}

export function ViewsActions({
	namespace,
	views,
	resultsAreLoaded,
}: ViewsActionsProps) {
	const visible = useVisibilityState(views.visibilitySelector);

	if (!views.viewsEnabled || !visible) {
		return null;
	}

	return (
		<div className="actions__action view-actions">
			<SelectView namespace={namespace} />
			{resultsAreLoaded && <ViewActions namespace={namespace} />}
		</div>
	);
}
